// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"76":"common","480":"special","527":"shopping","709":"order"}[chunkId] || chunkId) + "." + {"76":"0634214f","423":"0501a417","480":"802081c0","527":"1e992fdd","709":"3bd5ebff","927":"3e901413"}[chunkId] + ".js";
};